import { Component, Input, forwardRef } from '@angular/core';
import { DialogComponent, DialogService, WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { DetailService } from '@core/services/detail.service';
import { FeedbackMessageService } from '@shared/services/feedback-message.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { EntityService } from '@shared/services/entity.service';
import { CardModule } from '@progress/kendo-angular-layout';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FaIconComponent, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { RemoveEvent } from '@progress/kendo-angular-upload';
import { ListBoxModule, ListBoxToolbarConfig } from '@progress/kendo-angular-listbox';
import { BaseControl } from '../../ui/controls/base-control.model';
import { ListBoxControl } from '../../ui/controls/listbox-control.model';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { LabelModule } from '@progress/kendo-angular-label';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ReactiveFormsModule } from '@angular/forms';
import { GridKendoCardComponent } from '../grid-kendo-card/grid-kendo-card.component';
import { KendoCardFormControlComponent } from '../kendo-card-form-control/kendo-card-form-control.component';

@Component({
    selector: 'app-list-box',
    imports: [ListBoxModule,
        TextBoxModule,
        ButtonModule,
        ListBoxComponent,
        FaIconComponent,
        LabelModule],
    providers: [EntityService, FeedbackMessageService, TranslateService, DialogService, WindowService, DetailService],
    templateUrl: './list-box.component.html',
    styleUrls: ['./list-box.component.css']
})


export class ListBoxComponent {

  public itemList: string[] = [];

  public disable: boolean = false;

  @Input() control: BaseControl;
  listBoxControl: ListBoxControl;

  addIcon = faAdd;

  public toolbarSettings: ListBoxToolbarConfig = {
    position: "right",
    tools: ["remove"],
  };

  ngOnInit(): void {

    this.listBoxControl = this.control as ListBoxControl;
    this.itemList = this.listBoxControl.value;
    this.disable = this.listBoxControl.isReadOnly;

    if (this.disable) {
      this.toolbarSettings = {
        position: "right",
        tools: [],
      };
    }
  }

  addItem(textBox: any): void {
    //Add to the list box...
    var itemToAdd = textBox.value;
    this.itemList = [...this.itemList, itemToAdd];
    textBox.value = "";

    this.listBoxControl.value = this.itemList;
  }
}
